import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { ExportPayload, TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { JdDataService } from 'src/app/jd-data.service';
import * as _ from 'underscore';
declare const clevertap;

@Component({
    selector: 'app-talent-insights-ai',
    templateUrl: './talent-insights-ai.component.html',
    styleUrls: ['./talent-insights-ai.component.scss'],
    standalone: false
})
export class TalentInsightsAiComponent implements OnInit {

  companyname: any;
  @Input() requestaidata;
  @Input() insightstabname;
  @Input() jobDemandCount;
  /** Data is still loading */
  @Input() dataPending = false;

  aidata: any
  filterdata: any;
  locationsfilterdata: any = [];
  skillsfilterdata: any =[];
  functionsfilterdata: any = [];
  aifilter: any
  showshimmerloader: boolean = false;
  aisubscription: Subscription;
  @Input() totalcount;
  subscriptions: Subscription[] = [];
  successMessage: string = '';
  errorMessage: string = '';
  /** Tracks whether the next export should be PDF or Excel */
  pendingExportAction: 'PDF' | 'EXCEL' = 'PDF';
  /**
   * Normalized tab-names for insights-export API payload
   */
  normalizedTabNamesForInsightsExport: any = { 'overview': 'overview', 'location': 'location', 'company': 'company', 'education': 'education', 'skills': 'skills', 'industries': 'industries', 'titles': 'titles', 'profiles': 'profile', 'diversity': 'diversity' };

  constructor(private router: Router, private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService, private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsService: TalentInsightsService, private jdDataService: JdDataService, private aggReqObjectHandlerService: AggReqObjectHandlerService) { }

  ngOnInit() {
    this.personsearchservice.getTalentinsightsFilterAI.subscribe((response)=>{
      this.filterdata = response;
      this.getfilterdata();
    })
    this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.getfilterdata());

    // subscribe to insights-export subject for receiving data from tab-level component
    const insightsExportSubscription = this.talentInsightsService.insightsExportDataEvent.subscribe((payloadData: ExportPayload) => {
      if (this.pendingExportAction === 'EXCEL') {
        this.exportToExcel(payloadData);
      } else {
        this.exportToPDF(payloadData);
      }
      this.pendingExportAction = 'PDF'; // reset
    });
    this.subscriptions.push(insightsExportSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  generateai() {
    this.showshimmerloader = true
    this.aidata = '';
    const payload = {
      insightstabname: this.insightstabname,
      data: this.requestaidata,
      filters: this.aifilter
    }
    this.aisubscription = this.personsearchservice.gettalentinsightssummary(payload).subscribe((res:any)=>{
      this.aidata = res.data;
      this.showshimmerloader = false
      this.aidata = this.aidata.replace(/(?:\r\n|\r|\n)/g, '<br>')
    })
  }

  getfilterdata() {
    this.filterdata = this.filterDataHandlerService.fetchFilterData;
    if(this.filterdata) {
      this.aifilter = {
        locations:  this.filterdata && this.filterdata?.locationSelectedList?.length ? this.filterdata.locationSelectedList.filter(l => l.isExcluded == false).map(l => l.key):[],
        functions: this.filterdata && this.filterdata?.functionSelectedList ? this.filterdata.functionSelectedList.map(l => l.key):[],
        preferredskills: this.filterdata && this.filterdata?.skillsSelectedList?.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == false).map(s => s.key):[],
        mandatoryskills: this.filterdata && this.filterdata?.skillsSelectedList?.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == true).map(s => s.key):[],
        jobtitles: this.filterdata && this.filterdata?.jobTitleSelectedList?.length ? _.uniq(this.filterdata.jobTitleSelectedList.filter(jobTitle => jobTitle.isExcluded == false).map(j => j.key)):[],
        companies: this.filterdata && this.filterdata?.companySelectedList?.length ? this.filterdata.companySelectedList.filter(company => company.isExcluded == false).map(j => j.key): [],
        industries: this.filterdata && this.filterdata?.industrySelectedList?.length ? this.filterdata.industrySelectedList.map(industry => industry.key): [],
        fromyearsofexperiences: this.filterdata && this.filterdata?.yearsofexperienceFrom ? [this.filterdata.yearsofexperienceFrom]: [],
        toyearsofexperiences: this.filterdata && this.filterdata?.yearsofexperienceTo ? [this.filterdata.yearsofexperienceTo]: [],
        schools: this.filterdata && this.filterdata?.schoolSelectedList?.length ?this.filterdata.schoolSelectedList.map(s => s.key): [] ,
        degrees:  this.filterdata && this.filterdata?.educationSelectedList?.length ?  this.filterdata.educationSelectedList.map(e => e.key): [],
        keywords:  this.filterdata && this.filterdata?.keywordSelectedList?.length ? this.filterdata.keywordSelectedList: [],
        genders: this.filterdata && this.filterdata?.gender ? [this.filterdata.gender]: [],
        currentfromyearsofexperiences: this.filterdata && this.filterdata?.currentfromyearsofexperience ? [this.filterdata.currentfromyearsofexperience]: [],
        currenttoyearsofexperiences: this.filterdata && this.filterdata?.currenttoyearsofexperiences ? [this.filterdata.currenttoyearsofexperiences]: [],
        seniorities: this.filterdata && this.filterdata?.seniority?.length ? this.filterdata.seniority: [],
        companysizes: this.filterdata && this.filterdata?.companysize?.length ? this.filterdata.companysize: []
      }
      this.aidata = '';
      this.showshimmerloader = false;
      if(this.aisubscription)
      this.aisubscription.unsubscribe();
    //  if(this.filterdata.filterselected == 'yes') {
    //   this.generateai();
    //  }

   // }
    }
  }

  /**
   * Request insights export (PDF) from currently active tab
   */
  requestInsightsExport() {
    this.pendingExportAction = 'PDF';
    const currentlyActiveTab: string = this.talentInsightsService.currentTabTalentInsights;
    this.talentInsightsService.sendInsightsExportRequest({ type: 'SIGNAL', action: '', data: { currentTab: currentlyActiveTab } });
  }

  /**
   * Request insights export (Excel) from currently active tab
   */
  requestInsightsExportExcel() {
    this.pendingExportAction = 'EXCEL';
    const currentlyActiveTab: string = this.talentInsightsService.currentTabTalentInsights;
    this.talentInsightsService.sendInsightsExportRequest({ type: 'SIGNAL', action: '', data: { currentTab: currentlyActiveTab } });
  }

  /**
   * Initiate insights export to PDF using received payload
   * @param payloadData
   */
  exportToPDF(payloadData: ExportPayload) {
    const currentlyActiveTab = this.talentInsightsService.currentTabTalentInsights;
    const filtersData = this.filterDataHandlerService.fetchFilterData;
    const sharedReqData = this.aggService.getRequestWithFilters();

    // remove "searchastext" from filter data, excluded filters & perform basic transformations/changes
    const excludedJobtitles = sharedReqData?.exclude_jobtitles.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedLocations = sharedReqData?.exclude_locations.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedCompanies = sharedReqData?.exclude_companies.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedIndustries = sharedReqData?.exclude_industries.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedSchools = sharedReqData?.exclude_schoollocation.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedPastJobTitles = sharedReqData?.exclude_pastjobtitles.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const mandatorySkills = sharedReqData?.mandatoryskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedPreferredSkills  = sharedReqData?.exclude_preferredskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedMandatorySkills  = sharedReqData?.exclude_mandatoryskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedFunctions  = sharedReqData?.exclude_functions.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);

    Object.entries(filtersData).forEach(([key, value]) => {
      if(value && Array.isArray(value)) {
        filtersData[key] = (Array.isArray(value) ? value : [value]).filter(Boolean).map((s) => {
          if (typeof s === 'string') {
            if (s?.includes('.searchastext')) {
              return s?.split('.searchastext')[0];
            } else {
              return s?.split('.aisearch')[0];
            }
          } else {
            if (s?.key?.includes('.searchastext')) {
              return s?.key?.split('.searchastext')[0];
            } else {
              return s?.key?.split('.aisearch')[0];
            }
          }
        });
        if(key === 'seniority' || key === 'companysize'){
          filtersData[key] = filtersData[key].filter(item => (item.toLowerCase() != 'all'));
        } else if(key === 'jobTitleSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedJobtitles.includes(item.toLowerCase()));
        } else if(key === 'locationSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedLocations.includes(item.toLowerCase()));
        } else if (key === 'skillsSelectedList') {
  filtersData[key] = filtersData[key]
    .filter(item => {
      const skill = item?.toLowerCase();

      return !(
        excludedPreferredSkills.includes(skill) ||
        excludedMandatorySkills.includes(skill)
      );
    })
    .map(item => {
      const skill = item?.toLowerCase();

      return {
        key: item,
        isMandatory: mandatorySkills.includes(skill)
      };
    });
} else if(key === 'functionSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedFunctions.includes(item.toLowerCase()));
        }
      }
    });

    filtersData['excludedJobtitles'] = excludedJobtitles;
    filtersData['excludedLocations'] = excludedLocations;
    filtersData['excludedCompanies'] = excludedCompanies;
    filtersData['excludedIndustries'] = excludedIndustries;
    filtersData['excludedSchools'] = excludedSchools;
    filtersData['excludedPastJobTitles'] = excludedPastJobTitles;
        filtersData['excludedPreferredSkills'] = excludedPreferredSkills;
    filtersData['excludedMandatorySkills'] = excludedMandatorySkills;
    filtersData['excludedFunctions'] = excludedFunctions;
 filtersData.continentstobeincluded = (filtersData?.continentstobeincluded?.length) ? filtersData.continentstobeincluded : [];
    if(this.jdDataService.isComingFromJobDescription || this.jdDataService.isComingFromNLSearch){
      filtersData['JD_KEYS'] = this.jdDataService.jdDataFromSession;
      if(filtersData['JD_KEYS'] && filtersData['JD_KEYS'].currentlocation?.length == 0) {
        filtersData['JD_KEYS'].currentlocation = [{key: filtersData.continentstobeincluded[0]}]
      }
    }
        delete filtersData['continentstobeincluded'];


    //Continent sent in export payoload for talent-insights

    const payloadForExport: ExportPayload = {
      tab: this.normalizedTabNamesForInsightsExport[currentlyActiveTab],
      data: {
        ...payloadData,
        filters: filtersData
      }
    };
    if(this.aidata) {
      payloadForExport.data['aiData'] = this.aidata;
    } else {
      this.getfilterdata();
      payloadForExport.data['aiData'] = null;
      payloadForExport.data['aiRequestFilters'] = this.aifilter;
      payloadForExport.data['aiRequestPayload'] = this.requestaidata;
    }
    payloadForExport.data['aiInsightsTabName'] = this.insightstabname;

    // service call
    this.talentInsightsService.exportInsightsToPDFReport(payloadForExport).subscribe((res: any) => {
      if(res) {
        if(res.status === 'failure') {
          this.errorMessage = 'Error occured while generating the report';
        } else {
          const talentpoolParams = {
            "User ID": this.localstorageservice.getItem('userdata').userid,
            "Export Type": this.insightstabname,
            "Export Complete": "Yes",
            "Email Sent": "Yes",
            "File Format": `Webbtree_TalentInsights_${this.insightstabname}.pdf`
          };
          clevertap.event.push('Export Talent Insights', talentpoolParams);
          this.successMessage = 'You will receive the talent insights report on your email in a min.';
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      } else {
        this.errorMessage = 'Error occured while generating the report';
      }
    }, () => {
      this.errorMessage = 'Error occured while generating the report';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  }

  /**
   * Initiate insights export to Excel using received payload
   * @param payloadData
   */
  exportToExcel(payloadData: ExportPayload) {
    const currentlyActiveTab = this.talentInsightsService.currentTabTalentInsights;
    const filtersData = this.filterDataHandlerService.fetchFilterData;
    const sharedReqData = this.aggService.getRequestWithFilters();

    const excludedJobtitles = sharedReqData?.exclude_jobtitles.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedLocations = sharedReqData?.exclude_locations.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedCompanies = sharedReqData?.exclude_companies.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedIndustries = sharedReqData?.exclude_industries.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedSchools = sharedReqData?.exclude_schoollocation.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedPastJobTitles = sharedReqData?.exclude_pastjobtitles.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const mandatorySkills = sharedReqData?.mandatoryskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedPreferredSkills = sharedReqData?.exclude_preferredskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedMandatorySkills  = sharedReqData?.exclude_mandatoryskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedFunctions  = sharedReqData?.exclude_functions.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    Object.entries(filtersData).forEach(([key, value]) => {
      if (value && Array.isArray(value)) {
        filtersData[key] = (Array.isArray(value) ? value : [value]).filter(Boolean).map((s) => {
          if (typeof s === 'string') {
            return s?.includes('.searchastext') ? s?.split('.searchastext')[0] : s?.split('.aisearch')[0];
          } else {
            return s?.key?.includes('.searchastext') ? s?.key?.split('.searchastext')[0] : s?.key?.split('.aisearch')[0];
          }
        });
        if (key === 'seniority' || key === 'companysize') {
          filtersData[key] = filtersData[key].filter(item => (item.toLowerCase() !== 'all'));
        } else if (key === 'jobTitleSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedJobtitles.includes(item.toLowerCase()));
        } else if (key === 'locationSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedLocations.includes(item.toLowerCase()));
        }  else if (key === 'skillsSelectedList') {
  filtersData[key] = filtersData[key]
    .filter(item => {
      const skill = item?.toLowerCase();

      return !(
        excludedPreferredSkills.includes(skill) ||
        excludedMandatorySkills.includes(skill)
      );
    })
    .map(item => {
      const skill = item?.toLowerCase();

      return {
        key: item,
        isMandatory: mandatorySkills.includes(skill)
      };
    });
} else if (key === 'functionSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedFunctions.includes(item.toLowerCase()));
        }
      }
    });

    filtersData['excludedJobtitles'] = excludedJobtitles;
    filtersData['excludedLocations'] = excludedLocations;
    filtersData['excludedCompanies'] = excludedCompanies;
    filtersData['excludedIndustries'] = excludedIndustries;
    filtersData['excludedSchools'] = excludedSchools;
    filtersData['excludedPastJobTitles'] = excludedPastJobTitles;
    filtersData['excludedPreferredSkills'] = excludedPreferredSkills;
    filtersData['excludedMandatorySkills'] = excludedMandatorySkills;
    filtersData['excludedFunctions'] = excludedFunctions;

    if (this.jdDataService.isComingFromJobDescription) {
      filtersData['JD_KEYS'] = this.jdDataService.jdDataFromSession;
    }

    filtersData.continentstobeincluded = (filtersData?.continentstobeincluded?.length) ? filtersData.continentstobeincluded : [this.localstorageservice.getItem('talentRegion')];

    const payloadForExport: ExportPayload = {
      tab: this.normalizedTabNamesForInsightsExport[currentlyActiveTab],
      data: {
        ...payloadData,
        filters: filtersData
      }
    };
    if (this.aidata) {
      payloadForExport.data['aiData'] = this.aidata;
    } else {
      this.getfilterdata();
      payloadForExport.data['aiData'] = null;
      payloadForExport.data['aiRequestFilters'] = this.aifilter;
      payloadForExport.data['aiRequestPayload'] = this.requestaidata;
    }
    payloadForExport.data['aiInsightsTabName'] = this.insightstabname;

    this.talentInsightsService.exportInsightsToExcelReport(payloadForExport).subscribe((res: any) => {
      if (res) {
        if (res.status === 'failure') {
          this.errorMessage = 'Error occured while generating the report';
        } else {
          const talentpoolParams = {
            "User ID": this.localstorageservice.getItem('userdata').userid,
            "Export Type": this.insightstabname,
            "Export Complete": "Yes",
            "Email Sent": "Yes",
            "File Format": `Webbtree_TalentInsights_${this.insightstabname}.xlsx`
          };
          clevertap.event.push('Export Talent Insights', talentpoolParams);
          this.successMessage = 'You will receive the talent insights Excel report on your email in a min.';
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      } else {
        this.errorMessage = 'Error occured while generating the report';
      }
    }, () => {
      this.errorMessage = 'Error occured while generating the report';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  }

}
